// Action Types
export const SUBMIT_BASELINE_MARKET_DETAILS_REQUEST =
  "SUBMIT_BASELINE_MARKET_DETAILS_REQUEST";
export const SUBMIT_BASELINE_MARKET_DETAILS_SUCCESS =
  "SUBMIT_BASELINE_MARKET_DETAILS_SUCCESS";
export const SUBMIT_BASELINE_MARKET_DETAILS_FAILURE =
  "SUBMIT_BASELINE_MARKET_DETAILS_FAILURE";

// Action Creators
export const submitBaselineMarketDetailsRequest = (formData) => {
  return (dispatch) => {
    dispatch({
      type: SUBMIT_BASELINE_MARKET_DETAILS_REQUEST,
      payload: formData,
    });
  };
};

export const submitBaselineMarketDetailsSuccess = (message) => ({
  type: SUBMIT_BASELINE_MARKET_DETAILS_SUCCESS,
  payload: message,
});

export const submitBaselineMarketDetailsFailure = (error) => ({
  type: SUBMIT_BASELINE_MARKET_DETAILS_FAILURE,
  payload: error,
});
